export enum EmitterEvents {
    NEW_VERSION_AVAILABLE = 'new_version_available',
}
